import { normalize } from "normalizr";
import { detectedField } from "./schema";
import {assoc, dissoc, has, pathOr} from "ramda";
import { renameKeys } from "../../helpers/common";
import { OBJECT_TYPES } from "../../constants/project";
import { v4 as uuidv4 } from "uuid";

export const listDetectedField = {
  success: (response) => {
    const fields = pathOr([], ["body", "FieldsInfo", "Fields"], response);
    const fieldsData = fields.map((item) => {
      let data = renameKeys(
        {
          PageIndex: "pages",
          Type: "type",
          FieldName: "fieldName",
          AltFieldName: "altFieldName",
          Value: "text",
          Left: "left",
          Top: "top",
          Width: "width",
          Height: "height",
          Items: "items",
          AltItems: "altItems",
          AltValue: "altText",
        },
        item
      );

      // We will use the AltFieldName in priority than FieldName => So if we don't have AltFieldName => we will set AltFieldName value
      if (!has('altFieldName', data)) {
        data = assoc('altFieldName', data.fieldName, data)
      }

      // We will use the AltValue (AltText) in priority than Value(Text) => So if we have AltValue(AltText) => we will set Value(Text) is AltValue(AltText)
      if (has('altText', data)) {
        data = assoc('text', data.altText, data)
      }

      return {
        id: uuidv4(),
        ...data,
        objectType: OBJECT_TYPES.DETECTED_FIELD,
      };
    });

    return normalize(fieldsData, [detectedField]);
  },
};
